import { render, staticRenderFns } from "./CardAddress.vue?vue&type=template&id=4883f89c&scoped=true"
import script from "./CardAddress.vue?vue&type=script&lang=js"
export * from "./CardAddress.vue?vue&type=script&lang=js"
import style0 from "./CardAddress.vue?vue&type=style&index=0&id=4883f89c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883f89c",
  null
  
)

export default component.exports